import "../Pagination/Pagination.css";
import "./CursorPagination.css";

import React from "react";

import { ArrowLeftDarkIcon, ArrowRightDarkIcon } from "../../../assets";
import { LoadingSpinner } from "../../general";
import { Column, Row } from "../../layout";

export interface CursorPaginationProps {
  onPrevious: () => void;
  onNext: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  isLoading?: boolean;
}

export const CursorPagination: React.FC<CursorPaginationProps> = (props): JSX.Element | null => {
  const { onPrevious, onNext, hasNext, hasPrevious, isLoading = false } = props;
  return (
    <div className="Pagination Pagination_withCursor">
      {isLoading ? (
        <Row justify="center">
          <Column span={12}>
            <LoadingSpinner size="medium" type="dark" />
          </Column>
        </Row>
      ) : null}
      {isLoading === false && hasPrevious ? (
        <button className="PaginationItem PaginationItem_previous" onClick={onPrevious}>
          <ArrowLeftDarkIcon />
          <div className="PaginationItemText">Previous</div>
        </button>
      ) : null}
      {isLoading === false && hasNext ? (
        <button className="PaginationItem PaginationItem_next" onClick={onNext}>
          <div className="PaginationItemText">Next</div>
          <ArrowRightDarkIcon />
        </button>
      ) : null}
    </div>
  );
};
